import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Display the provided `text` input as an SVG element */
@Component({
  selector: 'plugins-user-text',
  standalone: false,
  template: `
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve">
      <text
        x="50%"
        y="52%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-size="12px"
      >
        {{ text() }}
      </text>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserTextInitialsComponent {
  readonly text = input.required<string>();
}
